'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseVisibilitySensor = require('@bibliocommons/base-visibility-sensor');

var _baseVisibilitySensor2 = _interopRequireDefault(_baseVisibilitySensor);

var _baseButtons = require('@bibliocommons/base-buttons');

var _ = require('../../../');

require('../styles/StickyToggleButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StickyToggleButton = function (_BcReactComponent) {
  _inherits(StickyToggleButton, _BcReactComponent);

  function StickyToggleButton(props) {
    _classCallCheck(this, StickyToggleButton);

    var _this = _possibleConstructorReturn(this, (StickyToggleButton.__proto__ || Object.getPrototypeOf(StickyToggleButton)).call(this, props));

    _this.state = { drawerToggleVisible: true };
    _this.bindAll('isVisible');
    return _this;
  }

  _createClass(StickyToggleButton, [{
    key: 'isVisible',
    value: function isVisible(visible) {
      if (visible !== this.state.drawerToggleVisible) {
        this.setState({ drawerToggleVisible: visible });
      }
    }
  }, {
    key: 'renderSticky',
    value: function renderSticky() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-sticky-toggle' },
        _react2.default.createElement(
          _.Toggle,
          { drawerActions: this.props.drawerActions },
          _react2.default.createElement(
            _baseButtons.PrimaryButton,
            { className: 'handle', handleClick: this.props.drawerActions.toggle },
            this.props.renderCompact()
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('cp-sticky-toggle-button', this.props.className) },
        _react2.default.createElement(
          _baseVisibilitySensor2.default,
          { isVisible: this.isVisible },
          _react2.default.createElement(
            _.Toggle,
            { drawerActions: this.props.drawerActions },
            _react2.default.createElement(
              _baseButtons.PrimaryButton,
              { handleClick: this.props.drawerActions.toggle },
              this.props.renderFull()
            )
          )
        ),
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          { transitionName: 'slide', transitionEnterTimeout: 500, transitionLeaveTimeout: 100 },
          this.state.drawerToggleVisible ? '' : this.renderSticky()
        )
      );
    }
  }]);

  return StickyToggleButton;
}(_baseBcReactComponent2.default);

exports.default = StickyToggleButton;


StickyToggleButton.propTypes = {
  className: _react.PropTypes.string,
  drawerActions: _react.PropTypes.objectOf(_react.PropTypes.func),
  renderFull: _react.PropTypes.func.isRequired,
  renderCompact: _react.PropTypes.func.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-drawer/lib/components/sticky-toggle-button/components/StickyToggleButton.component.js
// module id = 1067
// module chunks = 1